<template>
  <BContainer class="mb-5">
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BRow class="gap-y-5 mt-5">
      <BCol
        v-for="(form, index) in tradingTerms"
        :key="index"
        cols="12"
        md="3"
      >
        <BCard>
          <BCardTitle style="font-size: 15px;">
            {{ form.title }}
          </BCardTitle>
          <BCardBody
            class="p-1 d-flex flex-column"
          >
            <div class="d-flex flex-column align-items-center justify-content-center form-content">
              <BImg
                :src="pdfImageSrc"
                width="150%"
              />
            </div>
            <BButton
              class="align-self-end"
              variant="warning"
              size="sm"
              :href="getFormSrc(form.src)"
              target="_blank"
              download
            >
              View
            </BButton>
          </BCardBody>
        </BCard>
      </BCol>
    </BRow>

  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import { SSharedList } from '@/services/shared'

export default {
  name: 'SharedDocumentDownloadables',

  middleware: ['auth'],

  data () {
    return {
      fetching: false,
      tradingTerms: [
        {
          title: 'Customer Consent Form',
          src: 'consent-form.pdf'
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    }),

    pdfImageSrc () {
      return `${window.location.origin}/img/pdf.png`
    }
  },

  mounted () {
    if (this.currentUser) {
      this.getTradingTerms()
    }
  },

  methods: {
    getFormSrc (formName) {
      return `${window.location.origin}/forms/${formName}`
    },

    async getTradingTerms () {
      this.fetching = true

      return SSharedList.getTradingTerms().then(({ data }) => {
        this.tradingTerms = data
      }).catch(() => {
        this.tradingTerms = []
      }).finally(() => {
        this.fetching = false
      })
    }
  }
}
</script>
<style scoped>
.form-content {
  max-height: 220px;
  min-height: 220px;
}

@media screen and (max-width: 985px) {
  .form-content {
    max-height: 150px;
    min-height: 150px;
  }
}

@media screen and (max-width: 516px) {
  .form-content {
    max-height: 180px;
    min-height: 180px;
  }
}

</style>
